// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"acbf7ae14a9df9743ad0","655":"9a39fa5d501bceb23513"}[chunkId] + ".js";
};